// @flow
import type { Selector } from 'model/State';

const getIsTaxedUsOrder: Selector<boolean> = (state) =>
  !!state.cart.payload.ifSuccess(
    (cart) => cart && cart.billingOrganisationDetails.isoCountryCode === 'US' && cart.totalTax > 0,
  );

export default getIsTaxedUsOrder;
